// @ts-nocheck
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AUINotificationContext } from '@ancert/aui-notification-context';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Routes from './routes';

import { HOMEPAGE } from './constants/routes.constants';

import '@ancert/aui-styles/prime.scss';
import '@ancert/aui-styles/styles.scss';
import './assets/themes/portales.css'; // Este fichero no se debe modificar
import './assets/styles/global-overrides.css'; // Estilos globales personalizados
import Layout from './containers/Layout';
import { HeadProvider } from './context/head.context';
import resources from './i18n';

/**
 * Carga el idioma inicial desde
 * sessionStorage o del navegador.
 */
const savedLang = sessionStorage.getItem('i18n-lang');
const initialLang = (savedLang ?? navigator.language.slice(0, 2)) || 'es';
i18n.use(initReactI18next).init({
    resources,
    supportedLngs: ['es', 'ca', 'eu', 'gl', 'en', 'fr', 'de', 'it'],
    lng: initialLang,
    fallbackLng: 'es',
    interpolation: {
        escapeValue: false,
    },
});

/**
 * @component
 * @returns {React.ReactElement} - Devuelve un componente Layout
 */


function App() {
  return (
    <BrowserRouter basename={HOMEPAGE}>
      <HeadProvider>
      <AUINotificationContext>
        <Layout>
          <Routes />
        </Layout>
      </AUINotificationContext>
      </HeadProvider>
    </BrowserRouter>
  );
}

export default App;
